import Info from '@clearkit/icons/glyphs/Info';
import Hubspot from '@clearkit/icons/services/Hubspot';
import Salesforce from '@clearkit/icons/services/Salesforce';
import {
  CKBanner,
  CKBannerVariant,
  CKButton,
  CKIconStack,
} from '@clearkit/react';
import { Link } from 'react-router-dom';

import paths from '~/lib/paths';

const Logo = ({ service }) => {
  switch (service) {
    case 'hubspot':
      return <Hubspot />;
    case 'salesforce':
      return <Salesforce />;
    default:
      return null;
  }
};

const readableServiceName = (service) => {
  switch (service) {
    case 'hubspot':
      return 'Hubspot';
    case 'salesforce':
      return 'Salesforce';
    default:
      return null;
  }
};

const ConnectorError = ({ service }) => {
  const readableService = readableServiceName(service);

  return (
    <CKBanner
      variant={CKBannerVariant.warning}
      heading={`${readableService} has been disconnected`}
      description={`This segment needs access to fields in ${readableService}. Reconnect ${readableService} to restore this segment.`}
      icon={
        <CKIconStack
          base={<Logo service={service} />}
          badge={<Info className="fill-gradient-br-yellow" />}
        />
      }
      cta={
        <div>
          <CKButton
            variant="bold"
            variantColor="yellow"
            as={Link}
            to={paths.configuration(service)}>
            Fix this issue
          </CKButton>
        </div>
      }
    />
  );
};

export default ConnectorError;
